
const ErrorLoading = ({ pxSize = 100 }) => {
  return (
    <div className="alert alert-danger text-danger d-flex align-items-center">
      <p>Une erreur s&apos;est produite lors du chargement des données.</p>
    </div>
  );
};
export default ErrorLoading;
